import React, { Component } from 'react';
import { Button, Form, Icon, Upload } from 'antd';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';

import { isExcelFile } from './../../../../../system/support/helpers';

const { Dragger } = Upload;

class UploadForm extends Component {
    state = {
        fileList: []
    };

    handleChangeFile = event => {
        const { file, fileList } = event;

        this.setState({
            fileList: fileList.length ? [file] : []
        });
    };

    beforeUpload = () => false;

    render() {
        const { fileList } = this.state;
        const { downloadingMiaTemplate, form, t, uploadingMia, onDownloadMiaTemplate, onUploadMia } = this.props;
        const { getFieldDecorator } = form;

        return (
            <Form className="a-content--search-header" onSubmit={onUploadMia.bind(undefined, form)}>
                <Button className="mb-4" loading={downloadingMiaTemplate} onClick={onDownloadMiaTemplate}>
                    <Icon className={clsx({
                        'ml-3': downloadingMiaTemplate
                    })} type="download" />
                    {t('package:download_sample_file.main')}
                </Button>
                <Form.Item>
                    {getFieldDecorator('file', {
                        rules: [{
                            required: true,
                            message: t('validation:required', {
                                attribute: 'File'
                            })
                        }, {
                            validator: async (rule, value, callback) => {
                                if (value) {
                                    const { file, fileList } = value;
                                    const { name } = file;

                                    if (fileList.length && !isExcelFile(name)) {
                                        throw new Error(t('validation:mimes', {
                                            attribute: 'File',
                                            values: 'xlsx, xls'
                                        }))
                                    }
                                }

                                callback();
                            }
                        }]
                    })(
                        <Dragger
                            accept=".xlsx, .xls"
                            fileList={fileList}
                            beforeUpload={this.beforeUpload}
                            onChange={this.handleChangeFile}
                        >
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">{t('dragger_form.hint1')}</p>
                            <p className="ant-upload-hint">{t('dragger_form.hint2')}</p>
                        </Dragger>
                    )}
                </Form.Item>
                <div className="gflex gjustify-center mt-4">
                    <Button htmlType="submit" loading={uploadingMia} type="primary">
                        {t('upload')}
                    </Button>
                </div>
            </Form>
        );
    }
}

export default withTranslation()(Form.create()(UploadForm));
